/**
 * Regra de exibição de mensagem apagada, espelho de
 * `server/src/common/meta/mensagem-oculta.util.ts`.
 *
 * No WhatsApp a mensagem revogada continua na conversa como "mensagem apagada".
 * No Instagram e no Messenger o "unsend" pede o contrário: a diretriz da Meta é
 * que o conteúdo deixe de ser exibido — e o servidor, nessas plataformas, apaga
 * o conteúdo da linha e a filtra das leituras.
 *
 * A dimensão que decide é a `plataforma` GROSSA gravada na mensagem
 * (`WHATSAPP` / `INSTAGRAM` / `FACEBOOK`), não o tipo do inbox — o campo existe
 * na linha do Cassandra devolvida pela API, mesmo não estando declarado em
 * `WhizBaseMessage`.
 *
 * Existe como rede de segurança: o servidor já não devolve essas linhas. Cobre
 * mensagens gravadas antes desta feature e qualquer caminho de leitura que
 * escape do filtro de lá.
 */

const PLATAFORMAS_QUE_OCULTAM_APAGADAS = ['INSTAGRAM', 'FACEBOOK'];

export const mensagemOcultaPorExclusao = (mensagem: unknown): boolean => {
  const linha = mensagem as { apagada?: boolean | null; plataforma?: string | null } | null;
  if (!linha?.apagada) return false;
  return PLATAFORMAS_QUE_OCULTAM_APAGADAS.includes(linha.plataforma ?? '');
};
